import select2 from "select2";

class SelectStyles {

	constructor() {

		if( $(".orderby").length ) {
			select2($);
			$('.orderby').select2({
				minimumResultsForSearch: Infinity
			});
		}
	}

};

export default SelectStyles;